<template>
  <v-card>
    <v-card-title>
      <span class="title">Change</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <form @submit.prevent="formSubmit">

        <v-text-field
          v-model="division.initial"
          label="Initial"
          :error-messages="errors.collect('initial')"
          v-validate="'required|max:10'"
          :counter="10"
          data-vv-name="initial"
          required
        ></v-text-field>

        <v-text-field
          v-model="division.description"
          label="Description"
          :error-messages="errors.collect('description')"
          v-validate="'required'"
          data-vv-name="description"
          required
        ></v-text-field>

        <v-btn @click="formSubmit" dark color="accent" :loading="isLoading" :disable="isLoading">update</v-btn>
        <v-btn to="/division">cancel</v-btn>
      </form>
    </v-card-text>

    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'change-division',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      id: this.$route.params.id,
      division: {},
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  methods: {
    ...mapActions(['changeDivision', 'setActiveDivision']),
    /**
     *
     */
    formSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.changeDivision(this.division)
            .then(() => {
              let response = this.getResponse
              this.snackbar = true
              this.text =
                response.status === 200
                  ? 'Changed successfully.'
                  : response.data.message
              this.color = response.status === 200 ? 'success' : 'error'
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      getResponse: 'getResponse',
      getActiveDivision: 'getActiveDivision',
      isLoading: 'getLoading'
    })
  },
  mounted: function () {
    this.setActiveDivision(this.id)
      .then(() => {
        this.division = Object.assign({}, this.getActiveDivision)
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/division/ChangeDivision.vue